import React, { useEffect } from 'react';
import Cookies from 'universal-cookie'
import { useDispatch } from 'react-redux'
import { ICalculateLoanParams, LoanInitService } from '../../../service/LoanInitService'
import lenConfigService from '../../../service/LenConfigService'
import { SET_LOAN_CALCULATE_PARAMS, SET_LOAN_LIMITS } from '../../../store/actions/loan-calculator-actions'
import { SET_LEN_CONFIG } from '../../../store/actions/len-config-actions'
import { useSelector } from 'react-redux'
import { AppState } from '../../../store'

import { STORAGEKEYS } from '../../../common/keys'
import { affiliateAlternativeOffert, affiliateAlternativeOffertsNames } from '../../AffiliatePage/affiliatePartnersData'
import textContentsService from '../../../service/TextContentsService'
import { SET_INITIAL_TEXT_CONTENTS } from '../../../store/actions/text-contents-action'


/**
  * Custom hook obsługujący logikę strony bazowej - AppRoot
*/
const useAppRootLogic = () => {

   const dispatch = useDispatch()
   const loanInitService = new LoanInitService()
   const loanCalculatorState = useSelector((state: AppState) => state.loanCalculatorState)
   const cookie = new Cookies()
 
   useEffect(() => {
     (async () => {
      //  const loanLimitsParams = await loanInitService.getLoanLimits() //TODO Poprawić endpoint dla zadania 77206 - dodać możliwość zwracania różnych limitów pożyczki
 
       // const calculateLoanParams: ICalculateLoanParams = { //Przeliczenie dla maksymalnych możliwych parametrów pożyczki - Przywrócić w razie potrzeby
       //   instalments: loanLimitsParams.maxInstalments,
       //   requestedAmount: loanLimitsParams.maxRequestedAmount
       // }
 
       //Pobieramy konfigurację aplikacji
       const lenConfig = await lenConfigService.getLenConfig()
       const textContent = await textContentsService.getTextContents()

       dispatch({
          type: SET_INITIAL_TEXT_CONTENTS,
          payload: textContent.data
       })

       const alternativeAffiliateOfeertName: affiliateAlternativeOffertsNames | undefined = cookie.get(STORAGEKEYS.AFFILIATE_ALTERNATIVE_OFFERT_NAME)

       dispatch({
          type: SET_LEN_CONFIG,
          payload: lenConfig.data
       })
 
       if(loanCalculatorState.isOffertAlreadySet){ // Sytuacja w której użytkownik wszedł z linku afiliacyjnego z ODPOWIEDNIM PARAMETREM i MA JUŻ USTAWIONĄ OFERTĘ
        const alternativeLoanOffert = await loanInitService.calculateLoanOffert({ requestedAmount: loanCalculatorState.requestedAmount, instalments: loanCalculatorState.instalments })

          dispatch({
            type: SET_LOAN_CALCULATE_PARAMS,
            payload: alternativeLoanOffert
          })
       }
       else if (alternativeAffiliateOfeertName !== undefined) {
          const alternativeOffertParams = affiliateAlternativeOffert[alternativeAffiliateOfeertName]
          const calculateLoanParams: ICalculateLoanParams = { instalments: alternativeOffertParams.defaultInstalments, requestedAmount: alternativeOffertParams.defaultLoanAmount }

          //Wstępne przeliczenie - używamy maksymalnych dostępnych parametrów pożyczki lub tych podanych przez użytkownika na stronie wizytówce
          const alternativeLoanOffert = await loanInitService.calculateLoanOffert(calculateLoanParams)

          dispatch({
            type: SET_LOAN_LIMITS,
            payload: alternativeOffertParams.loanParams
          })

          dispatch({
            type: SET_LOAN_CALCULATE_PARAMS,
            payload: alternativeLoanOffert
          })
       }
       else {// Sytuacja w której żadne domyślne parametry oferty NIE ZOSTAŁY jeszcze podane (brak odpowiedniej oferty ustawionej za pomocą parametru z linku afiliacyjnego)
          const calculateLoanParams: ICalculateLoanParams = {
            instalments: loanInitService.defaultInstalmentsNumber,
            requestedAmount: loanInitService.defaultRequestedAmount
          }
 
          //Wstępne przeliczenie - używamy maksymalnych dostępnych parametrów pożyczki lub tych podanych przez użytkownika na stronie wizytówce
          const initialLoanOffert = await loanInitService.calculateLoanOffert(calculateLoanParams)

          dispatch({
            type: SET_LOAN_LIMITS,
            payload: loanInitService.loanLimitsForDefaultOffert
          })

          dispatch({
            type: SET_LOAN_CALCULATE_PARAMS,
            payload: initialLoanOffert
          })
       } 
     })()

   }, [loanCalculatorState.isOffertAlreadySet])
}

export default useAppRootLogic
